/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

const SRegulatoryBox: React.FC = () => {
	const { t } = useTranslation();
	return (
		<div className="bg-[#F8FAFC] border-l-4 border-[#2D3E50] p-6 rounded-r-xl flex items-start gap-4 shadow-sm">
			<span className="material-symbols-outlined text-[#2D3E50] mt-0.5">
				verified_user
			</span>
			<div>
				<h4 className="text-xs font-black text-slate-800 uppercase tracking-widest mb-1">
					{t("mediaReconcile.physicalReconciliation.compliances.heading")}
				</h4>
				<p className="text-[11px] text-slate-500 leading-relaxed font-medium">
					{t("mediaReconcile.physicalReconciliation.compliances.subtext")}
				</p>
			</div>
		</div>
	);
};

export default SRegulatoryBox;
